import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { DatePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Slider, Switch } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar } from "@progress/kendo-react-layout";
import { ListView } from "@progress/kendo-react-listview";
import { arrowRotateCwIcon, chartScatterSmoothLinesMarkersIcon, trashIcon } from "@progress/kendo-svg-icons";
import axios from "axios";
import { useState, useEffect, useRef, useMemo } from "react";
import { TransformComponent, TransformWrapper, useControls } from "react-zoom-pan-pinch";
import { AccessToken } from "../../../config/AccessToken";
import { loadingPanel } from "../../LoadingPanel";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { currentLocation } from "../../../assets/current-location";
import { AzureMapComponent } from "../../../pages/AzureMapComponent";
import React from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";
import h337 from "heatmap.js";
import { getStaticHeatmapGradient } from "../../../config/likelihoodColors";


export const HeatMap = () => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const localizationService = useLocalization();
    const [instance, accessTokenRequest] = AccessToken();
    let languageId: any = localStorage.getItem('languageId');

    const [loading, setLoading] = useState(false);

    const [devicesList, setDevicesList] = useState<any>([]);
    const [devicesWithSelection, setDevicesWithSelection] = useState<any>([]);
    const [selectedDevices, setSelectedDevices] = useState<string[]>([]);
    const [focusedItemMac, setFocusedItemMac] = useState<string | null>(null);

    const [checkedOnlyBound, setCheckedOnlyBound] = useState(false);
    const [checked, setChecked] = useState(false);
    const [isAdvanced, setIsAdvanced] = useState(false);
    const [analyzeEnabled, setAnalyzeEnabled] = useState(false);

    const [dateTimeState, setDateTimeState] = useState<any>({
        fromDate: new Date(),
        toDate: new Date(),
        fromHour: new Date(),
        toHour: new Date()
    });

    const [intervalTimeValue, setIntervalTimeValue] = useState<any>(null);
    const [intervalTimeName, setIntervalTimeName] = useState<any>('');
    const [formattedIntervalDate, setFormattedIntervalDate] = useState<any>(null);
    const [spaghettiChartMessage, setSpaghettiChartMessage] = useState<any>(null);

    const [infoDevice, setInfoDevice] = useState<any>([])

    const intervalTimeList = {
        "data": [
            {
                "id": -1,
                "name": localizationService.toLanguageString('configuration.analysis.path_history.custom', 'NOT_FOUND'),
                "value": -1
            },
            {
                "id": 0,
                "name": localizationService.toLanguageString('configuration.analysis.path_history.last_1_hour', 'NOT_FOUND'),
                "value": 60
            },
            {
                "id": 1,
                "name": localizationService.toLanguageString('configuration.analysis.path_history.last_3_hours', 'NOT_FOUND'),
                "value": 180
            },
            {
                "id": 2,
                "name": localizationService.toLanguageString('configuration.analysis.path_history.last_24_hours', 'NOT_FOUND'),
                "value": 1440
            },
            {
                "id": 3,
                "name": localizationService.toLanguageString('configuration.analysis.path_history.today', 'NOT_FOUND'),
                "value": 0
            },
            {
                "id": 4,
                "name": localizationService.toLanguageString('configuration.analysis.path_history.from_yesterday', 'NOT_FOUND'),
                "value": 1
            },
            {
                "id": 5,
                "name": localizationService.toLanguageString('configuration.analysis.path_history.last_3_days', 'NOT_FOUND'),
                "value": 4320
            },
        ]
    }

    const [error, setError] = useState(false);
    const [warningMessage, setWarningMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [mapGeoreferenced, setMapGeoreferenced] = useState(false);
    const [listMaps, setListMaps] = useState([]);
    const [listMapNames, setListMapNames] = useState([]);
    const [mapName, setMapName] = useState([]);
    const [selectedMap, setSelectedMap] = useState<any>([]);
    const [showZone, setShowZone] = useState<any>(false);
    const [showZoneMapGeo, setShowZoneMapGeo] = useState<any>([]);
    const [showSlider, setShowSlider] = useState<any>(false);
    const [showColor, setShowColor] = useState<any>(false);
    
    const [isValid, setIsValid] = useState<any>(false);


    const mapRef: any = useRef(null);
    const heatmapLayerRef = useRef<HTMLDivElement | null>(null);
    const heatmapInstanceRef = useRef<any>(null);

    const itemRefs: any = useRef({});

    type Coordinate = [number, number]; // una coppia [lat, lng]
    type CoordinateGroup = { coord: Coordinate[] };
    type StaticHeatPoint = { lon: number; lat: number; value: number; radius: number; datetime?: string | null };
    const heatmapIntensityMin = 0;
    const heatmapIntensityMax = 140;
    const [coordinates, setCoordinates] = useState<CoordinateGroup[]>([]);
    const [staticMapImageSrc, setStaticMapImageSrc] = useState('');
    const [staticMapSize, setStaticMapSize] = useState({ width: 0, height: 0 });
    const [staticHeatPoints, setStaticHeatPoints] = useState<StaticHeatPoint[]>([]);
    const [staticZones, setStaticZones] = useState<any[]>([]);
    const [heatmapRadius, setHeatmapRadius] = useState(0);
    const [heatmapIntensity, setHeatmapIntensity] = useState(heatmapIntensityMax);
    const [heatmapPointSize, setHeatmapPointSize] = useState(180);
    const heatmapRadiusRef = useRef(0);
    const heatmapIntensityRef = useRef(heatmapIntensityMax);
    const heatmapPointSizeRef = useRef(180);
    const showColorRef = useRef(false);

    const [isHeatmapReady, setIsHeatmapReady] = useState(false);

    const [noData, setNoData] = useState(true);
    const [messageNoData, setMessageNoData] = useState(false);
    const [messageTooData, setMessageTooData] = useState(false);
    const [transformWrapperKey, setTransformWrapperKey] = useState(0);

    const COUNTER_MAX_POINTS: number = Number(process.env.REACT_APP_COUNTER_MAX_POINTS) || 32000;


    useEffect(() => {
        heatmapRadiusRef.current = heatmapRadius;
    }, [heatmapRadius]);

    useEffect(() => {
        heatmapIntensityRef.current = heatmapIntensity;
    }, [heatmapIntensity]);

    useEffect(() => {
        heatmapPointSizeRef.current = heatmapPointSize;
    }, [heatmapPointSize]);

    useEffect(() => {
        showColorRef.current = showColor;
    }, [showColor]);


    const getDeviceList = async (flag: boolean, onlyBound?: any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            await axios.get(`${SERVER_URL}/device/active`, {
                headers,
                params: {
                    enabled: flag
                }
            })
                .then((res) => {
                    const data: any = res?.data?.data
                    let devicesWithSelection = [];

                    if (flag) {
                        if (onlyBound) {
                            const boundDevices = data.filter((device: any) => device.name != null);
                            setDevicesList(boundDevices);
                            devicesWithSelection = boundDevices.map((d: any) => ({ ...d, selected: false }));
                            setDevicesWithSelection(devicesWithSelection);
                        } else {
                            setDevicesList(data);
                            devicesWithSelection = data.map((d: any) => ({ ...d, selected: false }));
                            setDevicesWithSelection(devicesWithSelection);
                        }
                    }
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    //  call API on page load
    useEffect(() => {
        getDeviceList(true)
        getMapList();
    }, [])

    const onFilterChange = (ev: any) => {
        const value = ev?.toLowerCase();

        const filtered = devicesList.filter((device: any) =>
            Object.values(device).some(v =>
                v?.toString().toLowerCase().includes(value)
            )
        );

        // Mantieni lo stato di selezione
        setDevicesWithSelection(
            filtered.map((d: any) => ({
                ...d,
                selected: selectedDevices.includes(d.mac),
            }))
        );
    };

    const toggleDeviceSelection = (deviceMac: string) => {

        setMapName([])
        setFocusedItemMac(null)
        setAnalyzeEnabled(false)
        //setIntervalTimeValue(null)
        //setIntervalTimeName(null)
        setIsValid(false)

        setSelectedDevices(prev => {
            let newSelected;
            const isSelected = prev.includes(deviceMac);

            if (isSelected) {
                newSelected = prev.filter(mac => mac !== deviceMac);
            } else {
                if (prev.length >= 3) return prev;
                newSelected = [...prev, deviceMac];
            }

            setDevicesWithSelection((prevDevices: any) =>
                prevDevices.map((d: any) =>
                    d.mac === deviceMac ? { ...d, selected: !d.selected } : d
                )
            );

            if (newSelected.length === 0) {
                setFocusedItemMac(null);
            } else if (!isSelected) {
                setFocusedItemMac(deviceMac);
            } else {
                if (focusedItemMac === deviceMac) {
                    setFocusedItemMac(newSelected[0] || null);
                }
            }

            newSelected.length === 0 ?
                (
                    setAnalyzeEnabled(false),
                    setChecked(false),
                    setIsValid(false),
                    setIsAdvanced(false),
                    setIntervalTimeValue(null),
                    setIntervalTimeName(null)
                )
                :
                null

            return newSelected;
        });

    };

    const convertToSystemLocal = (date: Date): string => {
        const utc = date.getTime()

        const localDate = new Date(utc);

        const pad = (n: number) => String(n).padStart(2, '0');
        return `${pad(localDate.getDate())}/${pad(localDate.getMonth() + 1)}/${localDate.getFullYear()}, ${pad(localDate.getHours())}:${pad(localDate.getMinutes())}:${pad(localDate.getSeconds())}`;
    }

    const onChangeIntervalTime = (ev: any) => {
        if (!ev?.value) {
            return;
        }

        const now = new Date();

        const midnightToday = new Date();
        midnightToday.setHours(0, 0, 0, 0);

        //const midnightYesterday = new Date(midnightToday.getTime() - 24 * 60 * 60 * 1000);
        const midnightYesterday = new Date(midnightToday);
        midnightYesterday.setDate(midnightYesterday.getDate() - 1);

        const midnightThreeDaysAgo = new Date(midnightToday);
        midnightThreeDaysAgo.setDate(midnightThreeDaysAgo.getDate() - 3);

        let timeAgo: Date = now;

        switch (ev.value.id) {
            case -1: // custom range
                setIsAdvanced(true);
                setIntervalTimeName(ev.value);
                setChecked(true);
                return;

            case 0: // last 1 hour
            case 1: // last 3 hours
            case 2: // last 24 hours
                timeAgo = new Date(now.getTime() - ev.value.value * 60 * 1000);
                setIsAdvanced(false);
                break;

            case 3: // today
                timeAgo = midnightToday;
                setIsAdvanced(false);
                break;

            case 4: // from yesterday
                timeAgo = midnightYesterday;
                setIsAdvanced(false);
                break;

            case 5: // last 3 days
                timeAgo = midnightThreeDaysAgo;
                setIsAdvanced(false);
                break;

            default:
                return;

        }


        const formattedIntervalDate = convertToSystemLocal(timeAgo);

        const startDate = timeAgo.toISOString();

        setIntervalTimeValue(startDate);
        setIntervalTimeName(ev.value);
        setFormattedIntervalDate(formattedIntervalDate);

        setChecked(true);
    }

    const switchOnlyBound = (event: any) => {
        setCheckedOnlyBound(event.target.value);
        getDeviceList(true, event.target.value)
        setMapName([])
        setIntervalTimeName(null)
        setSelectedDevices([])
        setFocusedItemMac(null)
        setAnalyzeEnabled(false)
        setChecked(false)
        setShowZone(false)
        setShowColor(false)
        setIsAdvanced(false)
    };

    const toSafeDateValue = (value: any, fallback: Date = new Date()) => {
        if (value instanceof Date && !isNaN(value.getTime())) {
            return value;
        }

        if (typeof value === 'string' && value.trim() !== '') {
            const parsed = new Date(value);
            if (!isNaN(parsed.getTime())) {
                return parsed;
            }

            const timeParts = value.split(':');
            if (timeParts.length >= 2) {
                const hours = Number(timeParts[0]);
                const minutes = Number(timeParts[1]);
                const seconds = Number(timeParts[2] ?? 0);

                if (Number.isFinite(hours) && Number.isFinite(minutes) && Number.isFinite(seconds)) {
                    const d = new Date(fallback);
                    d.setHours(hours, minutes, seconds, 0);
                    return d;
                }
            }
        }

        return fallback;
    };

    const mergeDateAndTime = (date: any, time: any) => {
        const safeDate = toSafeDateValue(date, new Date());
        const safeTime = toSafeDateValue(time, safeDate);
        const merged = new Date(safeDate);
        merged.setHours(safeTime.getHours(), safeTime.getMinutes(), safeTime.getSeconds(), 0);
        return merged;
    };

    const toWakeupTimestamp = (value?: string | number | Date | null): number | null => {
        if (value === null || value === undefined) {
            return null;
        }

        if (value instanceof Date) {
            const ts = value.getTime();
            return Number.isFinite(ts) ? ts : null;
        }

        if (typeof value === 'number') {
            return Number.isFinite(value) ? value : null;
        }

        if (typeof value !== 'string') {
            return null;
        }

        const raw = value.trim();
        if (!raw) {
            return null;
        }

        const hasExplicitTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(raw);

        // 1) Native parse for values with explicit timezone (ISO/RFC with Z or +/-HH:mm)
        if (hasExplicitTimezone) {
            const direct = new Date(raw).getTime();
            if (Number.isFinite(direct)) {
                return direct;
            }
        }

        // 2) "YYYY-MM-DD HH:mm:ss" or "YYYY-MM-DDTHH:mm:ss" (without timezone): interpret as UTC.
        const ymdMatch = raw.replace(',', '').match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
        if (ymdMatch) {
            const [, yyyy, mm, dd, hh = '0', min = '0', ss = '0'] = ymdMatch;
            const parsedUtc = Date.UTC(
                Number(yyyy),
                Number(mm) - 1,
                Number(dd),
                Number(hh),
                Number(min),
                Number(ss),
                0
            );

            return Number.isFinite(parsedUtc) ? parsedUtc : null;
        }

        // 3) "DD/MM/YYYY HH:mm:ss" or "DD/MM/YYYY, HH:mm:ss" (without timezone): interpret as UTC.
        const dmyMatch = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:,?\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
        if (dmyMatch) {
            const [, dd, mm, yyyy, hh = '0', min = '0', ss = '0'] = dmyMatch;
            const parsedUtc = Date.UTC(
                Number(yyyy),
                Number(mm) - 1,
                Number(dd),
                Number(hh),
                Number(min),
                Number(ss),
                0
            );

            return Number.isFinite(parsedUtc) ? parsedUtc : null;
        }

        // 4) Final fallback native parse (handles legacy/browser-specific formats).
        const fallback = new Date(raw).getTime();
        if (Number.isFinite(fallback)) {
            return fallback;
        }

        return null;
    };

    const selectedRangeDates = useMemo(() => {
        const now = new Date();

        if (checked && isAdvanced) {
            const fromDateValue = mergeDateAndTime(
                dateTimeState?.fromDate ?? now,
                dateTimeState?.fromHour ?? now
            );
            const toDateValue = mergeDateAndTime(
                dateTimeState?.toDate ?? now,
                dateTimeState?.toHour ?? now
            );

            if (fromDateValue.getTime() <= toDateValue.getTime()) {
                return { from: fromDateValue, to: toDateValue };
            }

            return { from: toDateValue, to: fromDateValue };
        }

        const parsedInterval = intervalTimeValue ? new Date(intervalTimeValue) : null;
        const fromDateValue = parsedInterval && !isNaN(parsedInterval.getTime())
            ? parsedInterval
            : now;

        return { from: fromDateValue, to: now };
    }, [checked, isAdvanced, dateTimeState, intervalTimeValue]);

    const sliderRangeLabels = useMemo(() => {
        if (checked && isAdvanced) {
            return {
                from: convertToSystemLocal(selectedRangeDates.from),
                to: convertToSystemLocal(selectedRangeDates.to)
            };
        }

        return {
            from: formattedIntervalDate || convertToSystemLocal(selectedRangeDates.from),
            to: convertToSystemLocal(selectedRangeDates.to)
        };
    }, [checked, isAdvanced, formattedIntervalDate, selectedRangeDates]);

    const heatmapPointSizeMin = 50;
    const heatmapPointSizeMax = 180;
    const sliderProgressRatio = useMemo(() => {
        return (Math.max(heatmapPointSizeMin, Math.min(heatmapPointSizeMax, heatmapPointSize)) - heatmapPointSizeMin) /
            (heatmapPointSizeMax - heatmapPointSizeMin);
    }, [heatmapPointSize]);

    const staticHeatStepIndex = useMemo(() => {
        if (!staticHeatPoints.length) {
            return 0;
        }

        return Math.min(staticHeatPoints.length - 1, Math.max(0, Math.round(sliderProgressRatio * (staticHeatPoints.length - 1))));
    }, [staticHeatPoints, sliderProgressRatio]);

    const staticHeatPointsWithTimestamp = useMemo(() => {
        return staticHeatPoints.map((point) => ({
            ...point,
            timestamp: toWakeupTimestamp(point.datetime ?? null)
        }));
    }, [staticHeatPoints]);

    const staticHeatTimelineBounds = useMemo(() => {
        let start = Number.POSITIVE_INFINITY;
        let end = Number.NEGATIVE_INFINITY;

        staticHeatPointsWithTimestamp.forEach((point) => {
            if (point.timestamp === null) {
                return;
            }

            if (point.timestamp < start) {
                start = point.timestamp;
            }
            if (point.timestamp > end) {
                end = point.timestamp;
            }
        });

        if (!Number.isFinite(start) || !Number.isFinite(end)) {
            return null;
        }

        return { start, end };
    }, [staticHeatPointsWithTimestamp]);

    const staticHeatProgressiveThresholdMs = useMemo(() => {
        if (!staticHeatTimelineBounds) {
            return null;
        }

        if (staticHeatTimelineBounds.end <= staticHeatTimelineBounds.start) {
            return staticHeatTimelineBounds.end;
        }

        return staticHeatTimelineBounds.start +
            (staticHeatTimelineBounds.end - staticHeatTimelineBounds.start) * sliderProgressRatio;
    }, [staticHeatTimelineBounds, sliderProgressRatio]);

    const staticHeatProgressiveTo = useMemo(() => {
        if (staticHeatProgressiveThresholdMs !== null) {
            return convertToSystemLocal(new Date(staticHeatProgressiveThresholdMs));
        }

        const startMs = selectedRangeDates.from.getTime();
        const endMs = selectedRangeDates.to.getTime();

        if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) {
            return sliderRangeLabels.to || '';
        }

        if (endMs <= startMs) {
            return convertToSystemLocal(selectedRangeDates.to);
        }

        const progressiveMs = startMs + (endMs - startMs) * sliderProgressRatio;
        return convertToSystemLocal(new Date(progressiveMs));
    }, [staticHeatProgressiveThresholdMs, selectedRangeDates, sliderProgressRatio, sliderRangeLabels.to]);

    const isValidYear = (date: Date) => {
        const year = date.getFullYear();
        return year >= 1000; // blocca 0000, 0001, ecc.
    };

    const handleChangeDate = (e: any) => {
        const name = e?.target?.name;
        const value = e?.value ?? e?.target?.value;

        if (!name) {
            return;
        }
        
        if (value && !isValidYear(value)) {
            return; // ignora input
        }

        setDateTimeState((prev: any) => {
            const updated = { ...prev, [name]: value };

            if (name === "toDate" && value && prev.fromDate && value < prev.fromDate) {
                return prev; // ignora update
            }

            if (name === "fromDate" && value) {
                updated.fromHour = mergeDateAndTime(value, prev.fromHour);
            }

            if (name === "toDate" && value) {
                updated.toHour = mergeDateAndTime(value, prev.toHour);
            }

            return updated;
        });

        setChecked(true);
    };

    const handleBlurDate = (e: any) => {
        const name = e?.target?.name;
        const value = e?.value ?? e?.target?.value;

        if (!name || !value) return;

        setDateTimeState((prev: any) => {
            const updated = { ...prev };

            const newDate = e.target.value;

            if (name === "toDate" && prev.fromDate && newDate < prev.fromDate) {
                updated.toDate = null;
            }

            if (name === "fromDate" && prev.toDate && newDate > prev.toDate) {
                updated.toDate = null;
            }

            return updated;
        });
    };
    const handleBlurTime = (e: any) => {
        const { name, value } = e.target;

        if (!value) return;

        setDateTimeState((prev: any) => {
            const updated = { ...prev };

            const newDate = e.target.value;

            if (name === "toHour" && prev.fromHour && newDate < prev.fromHour) {
                updated.toHour = null;
            }

            if (name === "fromHour" && prev.toHour && newDate > prev.toHour) {
                updated.fromHour = null;
            }

            return updated;
        });
    };

    const handleChangeTime = (e: any) => {
        const name = e?.target?.name;
        const value = e?.value ?? e?.target?.value;

        if (!name) {
            return;
        }

        setDateTimeState((prev: any) => {
            const updated = { ...prev, [name]: value };

            if (name === "toHour" && value && prev.fromHour && value < prev.fromHour) {
                return prev; // ignora update
            }

            if (name === "fromHour" && value) {
                updated.fromDate = mergeDateAndTime(prev.fromDate, value);
            }

            if (name === "toHour" && value) {
                updated.toDate = mergeDateAndTime(prev.toDate, value);
            }

            return updated;
        });

        setChecked(true);
    };

    const buildUtcRangeForRequests = () => {
        const nowUtc = new Date().toISOString();
        const useCustomRange = checked && isAdvanced;

        if (!useCustomRange) {
            return {
                startDate: intervalTimeValue,
                endDate: nowUtc
            };
        }

        const fromDate = dateTimeState?.fromDate ?? new Date();
        const toDate = dateTimeState?.toDate ?? new Date();
        const fromHour = dateTimeState?.fromHour ?? new Date();
        const toHour = dateTimeState?.toHour ?? new Date();

        const startDateUtc = mergeDateAndTime(fromDate, fromHour).toISOString();
        const endDateUtc = mergeDateAndTime(toDate, toHour).toISOString();

        return {
            startDate: startDateUtc,
            endDate: endDateUtc
        };
    }

    const retrieveWakeups = async (deviceMac: any, mapId?: any) => {
        setLoading(true);

        setCoordinates([]);
        setShowColor(false);
        showColorRef.current = false;

        const { startDate, endDate } = buildUtcRangeForRequests();

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params: any = {
                startDate,
                endDate
            };

            if (mapId) {
                params.mapId = mapId;
            }

            axios.post(`${SERVER_URL}/wakeup/${deviceMac}/logs/heatmap`, params, { headers })
                .then((response: any) => {

                    const data = response?.data?.data?.wakeUpLogs
                    if (data?.length == 0) {
                        setAnalyzeEnabled(false);
                        setNoData(true);
                        setMessageNoData(true);

                        setTimeout(() => {
                            setMessageNoData(false);
                        }, 3000);

                        setLoading(false)
                        return
                    }

                    const coordinatesList: any = data
                    const mapId: any = response?.data?.data?.mapId

                    const currCoordinates = coordinatesList?.map((coord: any) => ({
                        long: coord.position.longitude,
                        lat: coord.position.latitude,
                        color: coord.position.color,
                        datetime: coord.datetime,
                        lastPositionDatetime: coord.lastPositionDatetime,
                        likelihood: coord.likelihood
                    }));

                    setCoordinates(prev => [...prev, { coord: [currCoordinates] }]);

                    setIsHeatmapReady(true);

                    setInfoDevice(currCoordinates);

                    getMapById(mapId, currCoordinates);

                    setSpaghettiChartMessage(true);
                    setAnalyzeEnabled(true);
                    setNoData(false);
                    setShowZone(false)
                    setShowSlider(false)

                    setTimeout(() => {
                        setSpaghettiChartMessage(false);
                    }, 3000);

                    setShowZone(false)

                    setLoading(false)
                }).catch((data) => {
                    if (data?.response.data.errorMessage == 'Error executing the API: Start date must be before end date') {
                        setError(true)
                        if (languageId == 'it-IT') {
                            setErrorMessage("Errore: La data di inizio deve essere prima della data di fine");
                        } else {
                            setErrorMessage("Error: Start date must be before end date");
                        }
                    }else if(data?.response.data.errorMessage == 'Error executing the API: There are no wakeups available for the selected map') {
                        setWarningMessage(true)
                        if (languageId == 'it-IT') {
                            setErrorMessage("Non ci sono wakeup disponibili per la mappa selezionata");
                        } else {
                            setErrorMessage("There are no wakeups available for the selected map");
                        }
                    }
                    if (!error) {
                        setTimeout(() => {
                            setError(false);
                        }, 3000);
                    }
                    if (!warningMessage) {
                        setTimeout(() => {
                            setWarningMessage(false);
                        }, 3000);
                    }
                    setLoading(false)
                })
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const getMapById = async (mapId: any, coordinates?: any) => {

        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/map/${mapId}`, { headers })
                .then((res) => {
                    const mapSelected = res?.data.data

                    mapSelected.georeferenced != 1 ? setMapGeoreferenced(false) : setMapGeoreferenced(true)

                    renderSelectedMap(mapSelected, coordinates)

                    setSelectedMap(mapSelected)
                    setMapName(mapSelected.name)

                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    setLoading(false);
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const renderSelectedMap = (map: any, coordinates?: any) => {
        if (!map?.image) {
            setStaticMapImageSrc('');
            setStaticMapSize({ width: 0, height: 0 });
            setStaticHeatPoints([]);
            return;
        }

        const imageSrc = `data:image/jpeg;base64, ${map.image}`;
        setStaticMapImageSrc(imageSrc);

        const image = new Image();
        image.src = imageSrc;
        image.onload = () => {
            const width = image.naturalWidth;
            const height = image.naturalHeight;
            setStaticMapSize({ width, height });

            if (Array.isArray(coordinates)) {
                const heatPoints:any = coordinates
                    .filter((coord: any) => Boolean(coord))
                    .map((coord: any) => {
                        const lng = Number(coord?.long);
                        const lat = Number(coord?.lat);

                        if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
                            return null;
                        }

                        const normalizedLng = Math.max(0, Math.min(1, lng));
                        const normalizedLat = Math.max(0, Math.min(1, lat));

                        const rawColor = `${coord?.color ?? '198792'}`;
                        const likelihood = typeof coord?.likelihood === 'number' ? coord.likelihood : 0;
                        const normalizedLikelihood = Math.max(0, Math.min(1, likelihood));
                        const normalizedIntensity = Math.max(0, Math.min(1, heatmapIntensityRef.current / heatmapIntensityMax));
                        const sewioIntensity = Math.pow(normalizedIntensity, 2.6);
                        const intensityFactor = 0.03 + sewioIntensity * 1.5;
                        const pointCompression = 0.05 + normalizedIntensity * 0.5;
                        const pointSizeFactor = Math.max(0.25, heatmapPointSizeRef.current / 100) * pointCompression;
                        const radiusBase = Math.max(8, heatmapRadiusRef.current || 24);
                        const baseValue = showColorRef.current ? Math.max(1, Math.round(normalizedLikelihood * 100)) : 65;
                        const likelihoodMultiplier = showColorRef.current ? (0.8 + (1 - normalizedLikelihood) * 0.8) : 1;

                        return {
                            lon: normalizedLng,
                            lat: normalizedLat,
                            value: baseValue,
                            radius: Math.max(1, Math.round(radiusBase * intensityFactor * pointSizeFactor * likelihoodMultiplier)),
                            datetime: coord?.datetime ?? coord?.lastPositionDatetime ?? null
                        };
                    })
                    .filter((point: any) => point !== null);

                setStaticHeatPoints(heatPoints);
            } else {
                setStaticHeatPoints([]);
            }
        };

    }

    const changeMap = (event: any) => {

        let currMap: any = ''
        if (event?.value != undefined) {
            currMap = event?.value ?? event ?? ''
        } else {
            currMap = event.name ?? event ?? ''
        }

        const currListMaps: any = listMaps
        const isMapGeo = currListMaps?.find((map: any) => map.name == currMap)?.georeferenced
        const booleanIsMapGeo: any = isMapGeo == 0 ? false : true
        localStorage.setItem('mapGeorefenced', booleanIsMapGeo)
        setMapGeoreferenced(booleanIsMapGeo)

        let mapSelected = currListMaps?.find((map: any) => map.name == currMap)
        const updateMapSelected = mapSelected ?? currListMaps?.find((map: any) => map.id == currMap)
        if (updateMapSelected == null) return

        checkResults(selectedDevices[0], updateMapSelected.id);

        setSelectedMap(updateMapSelected)
        setMapName(updateMapSelected.name)

        //setAnalyzeEnabled(true)
        //setShowZone(false)
        //setIsValid(false)

        //getMapById(updateMapSelected?.id)
    }

    const getZoneList = async (mapId: number, isGeoreferenced?: boolean) => {

        if (mapId == null || mapId == undefined) return

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/zone/bymapid/${mapId}?isGeoreferenced=${isGeoreferenced}`, { headers })
                .then((res) => {
                    const listZones = res?.data?.data

                    if (!isGeoreferenced) {
                        setStaticZones(listZones ?? []);
                    } else {
                        setShowZoneMapGeo(listZones)
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }
    }

    const Controls = () => {
        const { zoomIn, zoomOut, resetTransform } = useControls();

        return (
            <div className="k-button" style={{ background: 'none', border: 'none', marginTop: '10px' }}>
                <button
                    style={{
                        position: 'absolute',
                        width: '32px',
                        height: '32px',
                        zIndex: 10,
                        top: '0px',
                        left: '10px',
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        cursor: 'pointer'
                    }}
                    title={localizationService.toLanguageString('map.zoom_in', 'NOT_FOUND')}
                    onClick={() => zoomIn()}>+</button>
                <button
                    style={{
                        position: 'absolute',
                        width: '32px',
                        height: '32px',
                        zIndex: 10,
                        top: '0px',
                        left: '47px',
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        cursor: 'pointer'
                    }}
                    title={localizationService.toLanguageString('map.zoom_out', 'NOT_FOUND')}
                    onClick={() => zoomOut()}>-</button>
                <button
                    style={{
                        position: 'absolute',
                        width: '32px',
                        height: '32px',
                        zIndex: 10,
                        top: '0px',
                        left: '84px',
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        cursor: 'pointer'
                    }}
                    title={localizationService.toLanguageString('map.reset_zoom', 'NOT_FOUND')}
                    onClick={() => resetTransform()}
                >
                    <SvgIcon icon={currentLocation} />
                </button>

            </div>
        );
    };

    useEffect(() => {
        if (focusedItemMac && itemRefs.current[focusedItemMac]) {
            itemRefs.current[focusedItemMac].focus();
        }
    }, [focusedItemMac]);

    const getMapList = async () => {

        const commonOperations = async (accessToken: any) => {
            try {
                const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
                const res = await axios.get(`${SERVER_URL}/map/full/list`, { headers });
                const data = res?.data.data;

                if (!data?.length) {
                    setLoading(false);
                    return;
                }

                const mapsList = data;
                const mapNames = data.map((map: any) => map.name);

                setListMaps(mapsList);
                setListMapNames(mapNames);

            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(accessTokenRequest);
                }
            }
        };


        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }
    }

    const toDateSafe = (value: any) => {
        if (!value) return null;

        if (value instanceof Date) return value; // giÃ  una Date

        if (typeof value === 'string') {
            // tenta di interpretare la stringa DD/MM/YYYY HH:mm:ss
            const [datePart, timePart] = value.split(' ');
            if (!datePart) return null;
            const [day, month, year]: any = datePart.replace(',', '').split('/');
            const [hour = 0, minute = 0, second = 0]: any = (timePart || '').split(':');

            const d: any = new Date(year, month - 1, day, hour, minute, second);
            return isNaN(d.getTime()) ? null : d;
        }

        return null;
    };

    const [filter, setFilter] = useState("");
    const [filteredDevices, setFilteredDevices] = useState(devicesWithSelection);

    useEffect(() => {
        const safeDevices = (devicesWithSelection || [])
            .filter((d: any) => d && typeof d.mac === "string")
            .map((d: any) => ({
                ...d,
                displayName: d.name && d.name.trim() !== "" ? d.name : d.mac,
            }));

        if (!filter) {
            setFilteredDevices(safeDevices);
        } else {
            const lower = filter.toLowerCase();
            setFilteredDevices(
                safeDevices.filter((d: any) => {
                    const name = (d.name || "").toLowerCase();
                    const mac = d.mac.toLowerCase();
                    return name.includes(lower) || mac.includes(lower);
                })
            );
        }
    }, [filter, devicesWithSelection]);

    const resetHeatmapRender = () => {
        // Clear previous visualization before running a new analysis.
        setAnalyzeEnabled(false);
        setNoData(true);
        setIsHeatmapReady(false);
        setIsValid(false);
        setCoordinates([]);
        setStaticMapImageSrc('');
        setStaticMapSize({ width: 0, height: 0 });
        setStaticHeatPoints([]);
        setStaticZones([]);
        setSelectedMap([]);
        setMapName([]);
        setHeatmapRadius(0);
        setHeatmapIntensity(heatmapIntensityMax);
        setHeatmapPointSize(heatmapPointSizeMax);
        heatmapRadiusRef.current = 0;
        heatmapIntensityRef.current = heatmapIntensityMax;
        heatmapPointSizeRef.current = heatmapPointSizeMax;
        setInfoDevice([]);
        setShowSlider(false);
        setShowColor(false);
        showColorRef.current = false;
        setShowZone(false);
        setShowZoneMapGeo([]);
        setSpaghettiChartMessage(false);
        setMessageNoData(false);
        setMessageTooData(false);
        setError(false);
        setWarningMessage(false);

        if (heatmapInstanceRef.current) {
            heatmapInstanceRef.current.setData({ max: 100, data: [] });
        }

        if (heatmapLayerRef.current) {
            heatmapLayerRef.current.innerHTML = '';
        }

        heatmapInstanceRef.current = null;
    };

    const checkResults = async (deviceMac: any, mapId?: any) => {

        resetHeatmapRender();

        // Force a fresh zoom/pan canvas tree on each analysis run.
        setTransformWrapperKey((prev) => prev + 1);

        setLoading(true);
        const { startDate, endDate } = buildUtcRangeForRequests();

        const commonOperations = async (accessToken: any) => {
            try {
                const params = {
                    startDate,
                    endDate,
                    mac: [deviceMac]
                };
                const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
                const res = await axios.post(`${SERVER_URL}/WakeUp/count`, params, { headers });
                const data = res?.data.data;

                if (data <= COUNTER_MAX_POINTS) {
                    if (data == 0) {
                        resetHeatmapRender();
                        setIsValid(false)
                        setLoading(false);
                        setMessageNoData(true);

                        setTimeout(() => {
                            setMessageNoData(false);
                        }, 3000);
                    } else {
                        setIsValid(true)
                        retrieveWakeups(deviceMac, mapId);
                    }
                } else {
                    setIsValid(false)
                    setChecked(false)
                    setMessageTooData(true);
                    setTimeout(() => {
                        setMessageTooData(false);
                    }, 3000);
                    setLoading(false);
                    return;
                }

            } catch (error: any) {
                const errorMessage = error?.response?.data?.errorMessage || '';
                if (errorMessage.includes('Start date must be before end date')) {
                    setError(true);
                    if (languageId == 'it-IT') {
                        setErrorMessage("Errore: La data di inizio deve essere prima della data di fine");
                    } else {
                        setErrorMessage("Error: Start date must be before end date");
                    }
                } else if (errorMessage.includes('There are no wakeups available for the selected map')) {
                    setWarningMessage(true);
                    if (languageId == 'it-IT') {
                        setErrorMessage("Non ci sono wakeup disponibili per la mappa selezionata");
                    } else {
                        setErrorMessage("There are no wakeups available for the selected map");
                    }
                } else {
                    setError(true);
                    if (languageId == 'it-IT') {
                        setErrorMessage("Errore sconosciuto durante il controllo dei risultati");
                    } else {
                        setErrorMessage("Unknown error during results check");
                    }
                }
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(accessTokenRequest);
                }
                setTimeout(() => {
                    setError(false);
                }, 3000);
                if (!warningMessage) {
                    setTimeout(() => {
                        setWarningMessage(false);
                    }, 3000);
                }
                setLoading(false);
                return;
            }
        };


        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }

    }

    const enforceHeatmapOverlayStyle = (container: HTMLDivElement) => {
        // heatmap.js can rewrite container style (position: relative); keep it anchored as overlay.
        container.style.position = 'absolute';
        container.style.top = '0';
        container.style.right = '0';
        container.style.bottom = '0';
        container.style.left = '0';
        container.style.width = '100%';
        container.style.height = '100%';
        container.style.pointerEvents = 'none';
        container.style.zIndex = '3';
    };

    const createHeatmapInstance = (config: any) => {
        const originalGetContext = HTMLCanvasElement.prototype.getContext;

        HTMLCanvasElement.prototype.getContext = function (
            this: HTMLCanvasElement,
            contextId: '2d' | 'bitmaprenderer' | 'webgl' | 'webgl2',
            options?: CanvasRenderingContext2DSettings | WebGLContextAttributes
        ) {
            if (contextId === '2d') {
                const contextOptions = {
                    ...(options as CanvasRenderingContext2DSettings | undefined),
                    willReadFrequently: true
                };
                return originalGetContext.call(this, contextId, contextOptions);
            }

            return originalGetContext.call(this, contextId, options as any);
        } as typeof HTMLCanvasElement.prototype.getContext;

        try {
            return h337.create(config);
        } finally {
            HTMLCanvasElement.prototype.getContext = originalGetContext;
        }
    };

    useEffect(() => {
        const canRenderStaticHeatmap = analyzeEnabled && !noData && !mapGeoreferenced;

        if (!canRenderStaticHeatmap) {
            return;
        }

        if (!heatmapLayerRef.current || staticMapSize.width === 0 || staticMapSize.height === 0) {
            return;
        }

        const container = heatmapLayerRef.current;
        const normalizedIntensity = Math.max(0, Math.min(1, heatmapIntensity / heatmapIntensityMax));
        const sewioIntensity = Math.pow(normalizedIntensity, 2.6);
        const detailBoost = 1 - sewioIntensity;
        const baseRadius = Math.max(8, heatmapRadius || 24);
        const dynamicRadius = Math.max(3, Math.round(baseRadius * (0.26 + sewioIntensity * 1.7)));
        enforceHeatmapOverlayStyle(container);
        container.innerHTML = '';
        heatmapInstanceRef.current = createHeatmapInstance({
            container,
            maxOpacity: 0.28 + Math.pow(normalizedIntensity, 1.25) * 0.58,
            minOpacity: 0,
            blur: 0.08 + sewioIntensity * 0.85,
            radius: dynamicRadius,
            gradient: getStaticHeatmapGradient(showColor, detailBoost)
        });
        enforceHeatmapOverlayStyle(container);

        const canvases = container.querySelectorAll('canvas');
        canvases.forEach((canvas) => {
            canvas.style.position = 'absolute';
            canvas.style.top = '0';
            canvas.style.left = '0';
            canvas.style.width = '100%';
            canvas.style.height = '100%';
            canvas.style.display = 'block';
            canvas.style.pointerEvents = 'none';
        });
    }, [
        analyzeEnabled,
        noData,
        mapGeoreferenced,
        showColor,
        heatmapIntensity,
        staticMapImageSrc,
        staticMapSize.width,
        staticMapSize.height,
        heatmapRadius,
        transformWrapperKey
    ]);

    useEffect(() => {
        const instance = heatmapInstanceRef.current;
        if (!instance) {
            return;
        }

        if (heatmapLayerRef.current) {
            enforceHeatmapOverlayStyle(heatmapLayerRef.current);
        }

        if (!analyzeEnabled || noData || mapGeoreferenced || staticHeatPoints.length === 0) {
            instance.setData({ max: 100, data: [] });
            return;
        }

        if (!staticMapSize.width || !staticMapSize.height) {
            return;
        }

        let visibleHeatPoints = staticHeatPointsWithTimestamp;

        if (staticHeatProgressiveThresholdMs !== null) {
            visibleHeatPoints = staticHeatPointsWithTimestamp.filter((point) => {
                if (point.timestamp === null) {
                    return sliderProgressRatio >= 1;
                }

                return point.timestamp <= staticHeatProgressiveThresholdMs;
            });
        } else {
            visibleHeatPoints = staticHeatPointsWithTimestamp.slice(0, staticHeatStepIndex + 1);
        }

        const data = visibleHeatPoints.map((point) => ({
            // Exact SpaghettiChart#drawAllMarkers mapping using current map size.
            x: Math.round(point.lon * staticMapSize.width) - 5,
            y: Math.round(staticMapSize.height - point.lat * staticMapSize.height) - 5,
            value: Math.max(1, point.value),
            radius: point.radius
        }));

        const normalizedIntensity = Math.max(0, Math.min(1, heatmapIntensity / heatmapIntensityMax));
        const lowIntensityCompensation = Math.pow(1 - normalizedIntensity, 1.35);
        const maxScale = 1 + lowIntensityCompensation * 1.8;
        const maxValue = data.reduce((max: number, point: any) => Math.max(max, point.value), 1);
        instance.setData({ max: Math.max(1, Math.round(maxValue * maxScale)), data });
    }, [
        staticHeatPoints,
        staticHeatPointsWithTimestamp,
        staticHeatProgressiveThresholdMs,
        staticHeatStepIndex,
        analyzeEnabled,
        noData,
        mapGeoreferenced,
        staticMapSize.width,
        staticMapSize.height,
        transformWrapperKey,
        heatmapIntensity
    ]);

    useEffect(() => {
        const hasCoordinates = Boolean(coordinates[0]?.coord[0]?.length);

        if (isValid && selectedMap && hasCoordinates) {
            renderSelectedMap(selectedMap, coordinates[0]?.coord[0]);
        }

        if (showZone && selectedMap) {
            getZoneList(selectedMap.id, mapGeoreferenced)
        }
    }, [showColor, showZone, heatmapRadius, heatmapIntensity, heatmapPointSize]);

    const refreshDevices = () => {
        // Keep map rendering clean by remounting TransformWrapper.
        setTransformWrapperKey((prev) => prev + 1)
        setMapName([])
        setFocusedItemMac(null)
        setAnalyzeEnabled(false)
        setIntervalTimeValue(null)
        setIntervalTimeName(null)
        setChecked(false)
        setIsValid(false)
        setSelectedDevices([])
        getDeviceList(true, checkedOnlyBound)
        setIsAdvanced(false)
    }

    return (
        <>
            {loading && loadingPanel}
            {devicesList?.length == 0 || devicesList == undefined &&
                <div style={{ textAlign: 'center', padding: '20px', border: '1px dashed #ccc' }}>
                    <p>{localizationService.toLanguageString('configuration.devices.no_data', 'NOT_FOUND')}</p>
                </div>
            }
            {devicesList?.length > 0 &&
                <div
                    style={{
                        display: 'flex',
                        height: '100%'
                    }}
                >
                    <NotificationGroup
                        style={{
                            right: 0,
                            bottom: 50,
                            alignItems: "flex-start",
                            flexWrap: "wrap-reverse",
                        }}
                    >
                        <Fade enter={true} exit={true}>
                            {spaghettiChartMessage && (
                                <Notification
                                    type={{ style: "success", icon: true }}
                                    closable={true}
                                    onClose={() => setSpaghettiChartMessage(false)}
                                >
                                    <span>{localizationService.toLanguageString('configuration.analysis.path_history.map_loaded', 'NOT_FOUND')}</span>
                                </Notification>
                            )}
                            {messageNoData &&
                                <Notification
                                    type={{ style: "warning", icon: true }}
                                    closable={true}
                                    onClose={() => setMessageNoData(false)}
                                >
                                    <span>{localizationService.toLanguageString('configuration.analysis.path_history.no_data', 'NOT_FOUND')}</span>
                                </Notification>
                            }
                            {messageTooData &&
                                <Notification
                                    type={{ style: "warning", icon: true }}
                                    closable={true}
                                    onClose={() => setMessageTooData(false)}
                                >
                                    <span>{localizationService.toLanguageString('configuration.analysis.path_history.too_data', 'NOT_FOUND')}</span>
                                </Notification>
                            }
                            {error &&
                                <Notification
                                    type={{ style: "error", icon: true }}
                                    closable={true}
                                    onClose={() => setError(false)}
                                >
                                    <span>{errorMessage}</span>
                                    {/*<span>{localizationService.toLanguageString('configuration.analysis.path_history.no_data', 'NOT_FOUND')}</span>*/}
                                </Notification>
                            }
                            {warningMessage &&
                                <Notification
                                    type={{ style: "warning", icon: true }}
                                    closable={true}
                                    onClose={() => setWarningMessage(false)}
                                >
                                    <span>{errorMessage}</span>
                                </Notification>
                            }
                        </Fade>
                    </NotificationGroup>

                    {/* left panel */}
                    <div
                        style={{
                            background: "#F7F7F7",
                            padding: "0",
                            minWidth: '420px',
                            overflowY: "auto"
                        }}
                    >
                        <div
                            className="k-listview-item row p-2 align-middle"
                            style={{ margin: '0 auto' }}
                        >
                            <MultiSelect
                                data={filteredDevices}
                                dataItemKey="mac"
                                textField="displayName"
                                autoClose={true}
                                filterable={true}
                                onFilterChange={(e) => {
                                    setFilter(e.filter?.value || "")
                                    onFilterChange(e.filter?.value || "")
                                }}

                                value={devicesWithSelection
                                    .filter((d: any) => d?.selected && d?.mac)
                                    .map((d: any) => ({
                                        ...d,
                                        displayName: d.name && d.name.trim() !== "" ? d.name : d.mac,
                                    }))
                                }

                                onChange={(e: any) => {
                                    const newSelection = e.value || [];
                                    const newMacs = newSelection
                                        .map((d: any) => (typeof d === 'string' ? d : d?.mac))
                                        .filter((mac: any): mac is string => typeof mac === 'string' && mac.length > 0);

                                    const prevSelected = selectedDevices;

                                    if (newMacs.length > 1) {
                                        return;
                                    }

                                    const added = newMacs.find((mac: string) => !prevSelected.includes(mac));
                                    const removed = prevSelected.find((mac: string) => !newMacs.includes(mac));

                                    if (added && prevSelected.length >= 1) {
                                        return;
                                    }

                                    if (added) {
                                        toggleDeviceSelection(added);
                                    } else if (removed) {
                                        toggleDeviceSelection(removed);
                                    }
                                }}

                                itemRender={(li: any, itemProps: any) => {
                                    const device = itemProps.dataItem;
                                    if (!device || !device.mac) return li;

                                    const isSelected = device.selected;
                                    const isFocused = focusedItemMac === device.mac;
                                    const hasName = !!device.name && device.name.trim() !== "";

                                    return React.cloneElement(li, {
                                        ...li.props,
                                        style: {
                                            ...(li.props.style || {}),
                                            background: isSelected
                                                ? "#198692"
                                                : isFocused
                                                    ? "#198692"
                                                    : "#F7F7F7",
                                            color: isSelected || isFocused ? "#fff" : "#018CA5",
                                            fontSize: "12px",
                                            textTransform: "uppercase",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #ccc",
                                        },
                                        children: hasName ? (
                                            <>
                                                <span><strong>{device.name}</strong></span>
                                                <span
                                                    style={{
                                                        color: isSelected || isFocused ? "#fff" : "#018CA5",
                                                    }}
                                                >
                                                    ({device.mac})
                                                </span>
                                            </>
                                        ) : (
                                            <span
                                                style={{
                                                    color: isSelected || isFocused ? "#fff" : "#018CA5",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {device.mac}
                                            </span>
                                        ),
                                    });
                                }}

                                tagRender={(tagData: any, li) => {
                                    const device = tagData.dataItem;
                                    if (!device) return li;
                                    const label =
                                        device.name && device.name.trim() !== ""
                                            ? `${device.name} (${device.mac})`
                                            : device.mac;
                                    return (
                                        <span
                                            className="my-ms-tag"
                                            style={{
                                                background: "#198692",
                                                color: "#fff",
                                                borderRadius: "2px",
                                                padding: "2px 6px",
                                                margin: "2px",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                fontSize: "10px"
                                            }}
                                        >
                                            {label}
                                        </span>
                                    );
                                }}

                                placeholder={localizationService.toLanguageString('configuration.analysis.path_history.select_device', 'NOT_FOUND')}
                            />

                            <div style={{ margin: '10px 0px 0px 0px' }}>

                                {/*only bound, refresh, check, analysis*/}
                                <div style={{ display: 'flex' }}>

                                    {/*onlyBound*/}
                                    <label htmlFor="mySwitch" style={{ width: '285px' }}>
                                        <span style={{ margin: '0px 15px 0px 0px' }}>
                                            {localizationService.toLanguageString('configuration.analysis.path_history.only_binded', 'NOT_FOUND')}
                                        </span>
                                        <Switch
                                            id="mySwitch"
                                            onChange={switchOnlyBound}
                                            checked={checkedOnlyBound}
                                            size={'large'}
                                        />
                                    </label>

                                    <Button
                                        title={localizationService.toLanguageString('configuration.analysis.path_history.analyze', 'NOT FOUND')}
                                        className='analysis'
                                        disabled={!checked}
                                        onClick={async () => {
                                            for (const device of selectedDevices) {
                                                await checkResults(device);
                                            }
                                        }}
                                    >
                                        <Avatar
                                            className="analysis"
                                        >
                                            <SvgIcon icon={chartScatterSmoothLinesMarkersIcon} style={{ verticalAlign: 'baseline', margin: '10px' }} />
                                        </Avatar>
                                    </Button>

                                    {/* refresh device list button */}
                                    <Button
                                        className="plusParam"
                                        style={{ marginTop: '0px' }}
                                        onClick={() => {
                                            refreshDevices();
                                        }}
                                        title={localizationService.toLanguageString('configuration.analysis.path_history.refresh_list', 'NOT_FOUND')}
                                    >
                                        <Avatar
                                            className="plusParam"
                                        >
                                            <SvgIcon icon={arrowRotateCwIcon} style={{ margin: '8px' }} />
                                        </Avatar>
                                    </Button>

                                </div>

                                <div style={{ fontSize: '16px', opacity: `${selectedDevices.length == 0 ? '0.5' : '1'}` }}>
                                    {localizationService.toLanguageString('configuration.analysis.path_history.interval_time', 'NOT_FOUND')}
                                </div>

                                <DropDownList
                                    style={{
                                        width: "180px",
                                        opacity: `${selectedDevices.length == 0 ? '0.5' : '1'}`
                                    }}
                                    data={intervalTimeList.data}
                                    textField="name"
                                    value={intervalTimeName}
                                    disabled={selectedDevices.length == 0}
                                    onChange={onChangeIntervalTime}
                                />

                                {
                                    //advanced timeslot
                                    isAdvanced &&
                                    <div style={{ display: 'grid', width: '350px' }}>
                                        <div>
                                            <DatePicker
                                                name="fromDate"
                                                format="dd/MM/yyyy"
                                                validityStyles={false}
                                                label={localizationService.toLanguageString('configuration.analysis.path_history.from_date', 'NOT_FOUND')}
                                                value={dateTimeState.fromDate}
                                                width={150}
                                                required={true}
                                                onChange={handleChangeDate}
                                                onBlur={handleBlurDate}
                                                validationMessage={
                                                    dateTimeState.fromDate === null
                                                        ? `${localizationService.toLanguageString('configuration.analysis.path_history.from_date', 'NOT_FOUND')}`
                                                        : ""
                                                }
                                            />

                                            <DatePicker
                                                name="toDate"
                                                format="dd/MM/yyyy"
                                                style={{ marginLeft: '20px' }}
                                                validityStyles={false}
                                                label={localizationService.toLanguageString('configuration.analysis.path_history.to_date', 'NOT_FOUND')}
                                                value={dateTimeState.toDate}
                                                width={150}
                                                required={true}
                                                min={dateTimeState.fromDate || undefined}
                                                onChange={handleChangeDate}
                                                onBlur={handleBlurDate}
                                                validationMessage={
                                                    dateTimeState.toDate === null
                                                        ? `${localizationService.toLanguageString('configuration.analysis.path_history.to_date', 'NOT_FOUND')}`
                                                        : ""
                                                }
                                            />
                                        </div>

                                        <div style={{ display: 'flex', margin: '10px 0 10px 0' }}>
                                            <div>
                                                <TimePicker
                                                    format="HH:mm:ss"
                                                    name="fromHour"
                                                    validityStyles={false}
                                                    value={dateTimeState.fromHour}
                                                    width={150}
                                                    required={true}
                                                    onChange={handleChangeTime}
                                                    onBlur={handleBlurTime}
                                                    validationMessage={
                                                        dateTimeState.fromHour === null
                                                            ? `${localizationService.toLanguageString('configuration.analysis.path_history.from_hour', 'NOT_FOUND')}`
                                                            : ""
                                                    }
                                                />
                                            </div>
                                            <div style={{ marginLeft: '20px' }}>
                                                <TimePicker
                                                    format="HH:mm:ss"
                                                    name="toHour"
                                                    validityStyles={false}
                                                    value={dateTimeState.toHour}
                                                    width={150}
                                                    required={true}
                                                    min={dateTimeState.fromHour || undefined}
                                                    valid={(() => {
                                                        const { fromHour, toHour } = dateTimeState || {};

                                                        const from = toDateSafe(fromHour);
                                                        const to = toDateSafe(toHour);

                                                        if (!from || !to) return false;
                                                        return from.getTime() < to.getTime();
                                                    })()}
                                                    onChange={handleChangeTime}
                                                    onBlur={handleBlurTime}
                                                    validationMessage={
                                                        dateTimeState.toHour === null
                                                            ? `${localizationService.toLanguageString('configuration.analysis.path_history.to_hour', 'NOT_FOUND')}`
                                                            : `${localizationService.toLanguageString('configuration.analysis.path_history.to_hour', 'NOT_FOUND')}`
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }

                                {/*switch buttons*/}
                                <div style={{ display: 'flex', textAlign: 'center' }}>

                                    {/*show zones*/}
                                    <div style={{ marginTop: '10px' }}>
                                        <span style={{ marginRight: '5px', opacity: `${!analyzeEnabled || noData || selectedDevices.length == 0 ? '0.5' : '1'}` }}>
                                            {localizationService.toLanguageString('configuration.analysis.path_history.show_zones', 'NOT_FOUND')}
                                        </span>
                                        <Switch
                                            onChange={() => {
                                                setShowZone(!showZone)
                                                if (mapGeoreferenced) {
                                                    setShowZoneMapGeo([])
                                                } else {
                                                    setStaticZones([])
                                                }
                                            }}
                                            checked={showZone}
                                            disabled={!analyzeEnabled || noData || selectedDevices.length == 0}
                                            size={'large'}
                                        />
                                    </div>

                                </div>

                                {/*colorize with*/}
                                <div style={{ marginTop: '10px' }}>
                                    <Tooltip position="top" anchorElement="target">
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span
                                                style={{ marginRight: '5px', opacity: `${!analyzeEnabled || noData || selectedDevices.length == 0 ? '0.5' : '1'}` }}
                                                title={localizationService.toLanguageString('configuration.analysis.path_history.colorize_tooltip', 'NOT_FOUND')}
                                            >
                                                {localizationService.toLanguageString('configuration.analysis.path_history.colorize', 'NOT_FOUND')}
                                            </span>
                                            <Switch
                                                onLabel={showColor ? "Accuracy" : "Mac"}
                                                onChange={() => {
                                                    setShowColor((prev: boolean) => {
                                                        const next = !prev;
                                                        showColorRef.current = next;
                                                        return next;
                                                    })
                                                }}
                                                checked={showColor}
                                                disabled={!analyzeEnabled || noData || selectedDevices.length == 0}
                                                size={'large'}
                                            />
                                            <b style={{ marginLeft: '10px', opacity: `${!analyzeEnabled || noData || selectedDevices.length == 0 ? '0.5' : '1'}` }}>
                                                {!showColor ?
                                                    localizationService.toLanguageString('configuration.analysis.heatmap.mac', 'NOT_FOUND')
                                                    :
                                                    localizationService.toLanguageString('configuration.analysis.path_history.accuracy', 'NOT_FOUND')
                                                }
                                            </b>
                                        </div>
                                    </Tooltip>
                                </div>

                                {/*slider*/}
                                {!mapGeoreferenced && (
                                    <div style={{ marginTop: '12px', width: '250px' }}>
                                        {/*<div
                                            style={{
                                                marginBottom: '6px',
                                                opacity: `${!analyzeEnabled || noData || selectedDevices.length == 0 ? '0.5' : '1'}`,
                                                fontWeight: 600,
                                                fontSize: '13px'
                                            }}
                                        >
                                            {localizationService.toLanguageString('azure.radius', 'Radius')}
                                        </div>

                                        <Slider
                                            className="heatmap-radius-slider"
                                            style={{ width: '250px' }}
                                            min={0}
                                            max={180}
                                            step={5}
                                            value={heatmapRadius}
                                            onChange={(e: any) => {
                                                const next = Number(e.value);
                                                heatmapRadiusRef.current = next;
                                                setHeatmapRadius(next);
                                            }}
                                            disabled={!analyzeEnabled || noData || selectedDevices.length == 0}
                                        />*/}
                                        
                                        <div
                                            style={{
                                                marginBottom: '6px',
                                                opacity: `${!analyzeEnabled || noData || selectedDevices.length == 0 ? '0.5' : '1'}`,
                                                fontWeight: 600,
                                                fontSize: '13px'
                                            }}
                                        >
                                            {localizationService.toLanguageString('configuration.analysis.heatmap.heatmap_intensity', 'Heatmap intensity')}
                                        </div>
                                        <Slider
                                            className="heatmap-intensity-slider"
                                            style={{ width: '250px' }}
                                            min={heatmapIntensityMin}
                                            max={heatmapIntensityMax}
                                            step={1}
                                            value={heatmapIntensity}
                                            onChange={(e: any) => {
                                                const next = Number(e.value);
                                                heatmapIntensityRef.current = next;
                                                setHeatmapIntensity(next);
                                            }}
                                            disabled={!analyzeEnabled || noData || selectedDevices.length == 0}
                                        />

                                        <div
                                            style={{                                                
                                                marginBottom: '6px',
                                                opacity: `${!analyzeEnabled || noData || selectedDevices.length == 0 ? '0.5' : '1'}`,
                                                fontWeight: 600,
                                                fontSize: '13px'
                                            }}
                                        >
                                            {localizationService.toLanguageString('configuration.analysis.heatmap.heatmap_point_size', 'Heatmap point size')}
                                        </div>
                                        <Slider
                                            className="heatmap-point-size-slider"
                                            style={{ width: '250px' }}
                                            min={heatmapPointSizeMin}
                                            max={heatmapPointSizeMax}
                                            step={5}
                                            value={heatmapPointSize}
                                            onChange={(e: any) => {
                                                const next = Number(e.value) || heatmapPointSizeMax;
                                                heatmapPointSizeRef.current = next;
                                                setHeatmapPointSize(next);
                                            }}
                                            disabled={!analyzeEnabled || noData || selectedDevices.length == 0}
                                        />

                                        <div
                                            style={{
                                                marginTop: '8px',
                                                opacity: `${!analyzeEnabled || noData || selectedDevices.length == 0 ? '0.5' : '1'}`,
                                                fontSize: '12px',
                                                color: '#555',
                                                width: '250px'
                                            }}
                                        >
                                            {`${sliderRangeLabels.from || ''}${sliderRangeLabels.from && staticHeatProgressiveTo ? ' - ' : ''}${staticHeatProgressiveTo || ''}`}
                                        </div>
                                    </div>
                                )}

                                
                                {selectedDevices.length != 0 && (
                                    <div style={{ width: '230px', marginTop: '20px', fontWeight: 'bold' }}>
                                        {localizationService.toLanguageString('configuration.analysis.path_history.devices_selected', 'NOT_FOUND')}:

                                        {/*show selected devices*/}
                                        <ListView
                                            data={selectedDevices}
                                            style={{ height: '110px', background: 'transparent' }}
                                            item={(props: any) => (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        gap: '8px',
                                                        padding: '8px',
                                                        boxShadow: 'none',
                                                        fontSize: '13px',
                                                        textTransform: 'uppercase',
                                                        borderBottom: '1px solid #ccc'
                                                    }}
                                                >
                                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {props.dataItem}
                                                    </span>
                                                    <div
                                                        style={{
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                        onClick={() => toggleDeviceSelection(props.dataItem)}
                                                    >
                                                        <Avatar className="trash-icon-path-history">
                                                            <SvgIcon
                                                                icon={trashIcon}
                                                                style={{ verticalAlign: 'baseline', margin: '10px' }}
                                                            />
                                                        </Avatar>
                                                    </div>
                                                </div>
                                            )}
                                        />

                                        {/*show map list*/}
                                        {!noData && analyzeEnabled &&
                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: '16px',
                                                        opacity: `${!analyzeEnabled || (intervalTimeValue == null && !checked) || noData ? '0.5' : '1'}`
                                                    }}
                                                >
                                                    {localizationService.toLanguageString('configuration.analysis.path_history.maps', 'NOT_FOUND')}
                                                </div>
                                                <DropDownList
                                                    style={{
                                                        width: "180px",
                                                        opacity: `${!analyzeEnabled || (intervalTimeValue == null && !checked) || noData ? '0.5' : '1'}`
                                                    }}
                                                    data={listMapNames}
                                                    value={mapName.length > 0 ? mapName : undefined}
                                                    disabled={!analyzeEnabled || (intervalTimeValue == null && !checked) || noData}
                                                    onChange={(e: any) => changeMap(e)}
                                                />
                                            </div>
                                        }

                                    </div>
                                )}

                            </div>

                        </div>

                    </div>

                    {/* right panel */}
                    <div
                        //className="flex-left-child-element"
                        style={{ display: 'inline', width: '100%', minHeight: '300px', padding: '10px', background: "white", overflow: 'auto' }}
                    >

                        {/*map*/}
                        {analyzeEnabled && !noData &&
                            <>
                                <div
                                    style={{
                                        display: `${analyzeEnabled && !mapGeoreferenced && !noData ? 'block' : 'none'}`,
                                        border: '1px solid black',
                                    }}
                                >
                                   
                                    <TransformWrapper
                                        key={transformWrapperKey}
                                        initialScale={0.6}
                                        initialPositionX={0}
                                        initialPositionY={0}
                                        minScale={0.2}
                                        centerOnInit={true}
                                        centerZoomedOut={true}
                                        limitToBounds={true}
                                        smooth={true}
                                    >
                                        {({ zoomIn, zoomOut, resetTransform, centerView, zoomToElement, ...rest }) => (
                                            <>
                                                <div>
                                                    <Controls />
                                                </div>

                                                <TransformComponent
                                                    wrapperStyle={{
                                                        width: '100%',
                                                        height: '100%'
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: 'relative',
                                                            width: staticMapSize.width || 800,
                                                            height: staticMapSize.height || 500,
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            lineHeight: 0,
                                                            overflow: 'hidden'
                                                        }}
                                                    >
                                                        {staticMapImageSrc && (
                                                            <img
                                                                src={staticMapImageSrc}
                                                                alt="Heat map"
                                                                style={{
                                                                    display: 'block',
                                                                    width: staticMapSize.width || 800,
                                                                    height: staticMapSize.height || 500,
                                                                    userSelect: 'none',
                                                                    pointerEvents: 'none'
                                                                }}
                                                            />
                                                        )}

                                                        {showZone && staticZones?.length > 0 && (
                                                            <svg
                                                                width={staticMapSize.width || 800}
                                                                height={staticMapSize.height || 500}
                                                                viewBox={`0 0 ${staticMapSize.width || 800} ${staticMapSize.height || 500}`}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    pointerEvents: 'none',
                                                                    zIndex: 2
                                                                }}
                                                            >
                                                                {staticZones.map((zone: any, index: number) => {
                                                                    const points = (zone?.points ?? [])
                                                                        .map((point: any) => {
                                                                            const x = (point?.longitude ?? 0) * (staticMapSize.width || 800);
                                                                            const y = (1 - (point?.latitude ?? 0)) * (staticMapSize.height || 500);
                                                                            return `${x},${y}`;
                                                                        })
                                                                        .join(' ');

                                                                    return (
                                                                        <polygon
                                                                            key={`${zone?.id ?? 'zone'}-${index}`}
                                                                            points={points}
                                                                            fill={zone?.color || '#198792'}
                                                                            fillOpacity={0.35}
                                                                            stroke={zone?.color || '#198792'}
                                                                            strokeOpacity={0.75}
                                                                            strokeWidth={1.2}
                                                                        />
                                                                    );
                                                                })}
                                                            </svg>
                                                        )}

                                                        <div
                                                            ref={heatmapLayerRef}
                                                            style={{
                                                                position: 'absolute',
                                                                inset: 0,
                                                                pointerEvents: 'none',
                                                                zIndex: 3
                                                            }}
                                                        />
                                                    </div>
                                                </TransformComponent>

                                            </>
                                        )}
                                    </TransformWrapper>
                                </div>

                                <div
                                    ref={mapRef}
                                    style={{
                                        height: '100%',
                                        display: `${analyzeEnabled && mapGeoreferenced && !noData ? 'block' : 'none'}`
                                    }}
                                >
                                    {listMaps.length != 0 && mapGeoreferenced &&
                                        <AzureMapComponent
                                            map={selectedMap ?? localStorage.getItem('mapSelected')}
                                            zones={showZoneMapGeo ?? []}
                                            coordinatesList={coordinates}
                                            isHeatmapReady={isHeatmapReady}
                                            isAdvancedDate={checked}
                                            formattedIntervalDate={formattedIntervalDate}
                                            fromDate={sliderRangeLabels.from}
                                            toDate={sliderRangeLabels.to}
                                            showColor={showColor}
                                            showSlider={showSlider}
                                        />
                                    }
                                </div>
                                {/*}*/}
                            </>
                        }

                    </div>
                </div >
            }
        </>
    )
}